// @generated by protoc-gen-es v2.12.1 with parameter "target=ts,json_types=true"
// @generated from file events/v1/service.proto (package events.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_common_v1_annotations } from "../../common/v1/annotations_pb";
import type { DataType, DataTypeJson } from "../../common/v1/types_pb";
import { file_common_v1_types } from "../../common/v1/types_pb";
import type { Calendar, CalendarJson, Event, EventJson, Property, PropertyJson } from "./events_pb";
import { file_events_v1_events } from "./events_pb";
import type { FieldMask, FieldMaskJson, Timestamp, TimestampJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_field_mask, file_google_protobuf_struct, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file events/v1/service.proto.
 */
export const file_events_v1_service: GenFile =
	/*@__PURE__*/
	fileDesc(
		"ChdldmVudHMvdjEvc2VydmljZS5wcm90bxIJZXZlbnRzLnYxIjwKFExpc3RDYWxlbmRhcnNSZXF1ZXN0Eg4KBm9yZ19pZBgBIAEoCRIUCgx3b3Jrc3BhY2VfaWQYAiABKAkiPwoVTGlzdENhbGVuZGFyc1Jlc3BvbnNlEiYKCWNhbGVuZGFycxgBIAMoCzITLmV2ZW50cy52MS5DYWxlbmRhciIgChJHZXRDYWxlbmRhclJlcXVlc3QSCgoCaWQYAyABKAkiPAoTR2V0Q2FsZW5kYXJSZXNwb25zZRIlCghjYWxlbmRhchgBIAEoCzITLmV2ZW50cy52MS5DYWxlbmRhciJzChVDcmVhdGVDYWxlbmRhclJlcXVlc3QSDgoGb3JnX2lkGAEgASgJEhQKDHdvcmtzcGFjZV9pZBgCIAEoCRIMCgRuYW1lGAMgASgJEhIKCmNvbG9yX2NvZGUYBCABKAkSEgoKaXNfZGVmYXVsdBgFIAEoCCI/ChZDcmVhdGVDYWxlbmRhclJlc3BvbnNlEiUKCGNhbGVuZGFyGAEgASgLMhMuZXZlbnRzLnYxLkNhbGVuZGFyImgKFVVwZGF0ZUNhbGVuZGFyUmVxdWVzdBIlCghjYWxlbmRhchgBIAEoCzITLmV2ZW50cy52MS5DYWxlbmRhchIoCgRtYXNrGAIgASgLMhouZ29vZ2xlLnByb3RvYnVmLkZpZWxkTWFzayI/ChZVcGRhdGVDYWxlbmRhclJlc3BvbnNlEiUKCGNhbGVuZGFyGAEgASgLMhMuZXZlbnRzLnYxLkNhbGVuZGFyIiMKFURlbGV0ZUNhbGVuZGFyUmVxdWVzdBIKCgJpZBgBIAEoCSIYChZEZWxldGVDYWxlbmRhclJlc3BvbnNlIoEBCgtFdmVudEZpbHRlchIUCgxjYWxlbmRhcl9pZHMYASADKAkSLgoKc3RhcnRfdGltZRgCIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASLAoIZW5kX3RpbWUYAyABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wInEKEUxpc3RFdmVudHNSZXF1ZXN0Eg4KBm9yZ19pZBgBIAEoCRIUCgx3b3Jrc3BhY2VfaWQYAiABKAkSKwoGZmlsdGVyGAMgASgLMhYuZXZlbnRzLnYxLkV2ZW50RmlsdGVySACIAQFCCQoHX2ZpbHRlciI2ChJMaXN0RXZlbnRzUmVzcG9uc2USIAoGZXZlbnRzGAEgAygLMhAuZXZlbnRzLnYxLkV2ZW50Ih0KD0dldEV2ZW50UmVxdWVzdBIKCgJpZBgBIAEoCSIzChBHZXRFdmVudFJlc3BvbnNlEh8KBWV2ZW50GAEgASgLMhAuZXZlbnRzLnYxLkV2ZW50IiwKFEdldExpdmVFdmVudHNSZXF1ZXN0EhQKDGNhbGVuZGFyX2lkcxgBIAMoCSI5ChVHZXRMaXZlRXZlbnRzUmVzcG9uc2USIAoGZXZlbnRzGAEgAygLMhAuZXZlbnRzLnYxLkV2ZW50IjEKGUdldEV2ZW50UHJvcGVydGllc1JlcXVlc3QSFAoMY2FsZW5kYXJfaWRzGAEgAygJIq8BChpHZXRFdmVudFByb3BlcnRpZXNSZXNwb25zZRJJCgpwcm9wZXJ0aWVzGAEgAygLMjUuZXZlbnRzLnYxLkdldEV2ZW50UHJvcGVydGllc1Jlc3BvbnNlLlByb3BlcnRpZXNFbnRyeRpGCg9Qcm9wZXJ0aWVzRW50cnkSCwoDa2V5GAEgASgJEiIKBXZhbHVlGAIgASgOMhMuY29tbW9uLnYxLkRhdGFUeXBlOgI4ASLpAgoSQ3JlYXRlRXZlbnRSZXF1ZXN0Eg4KBm9yZ19pZBgBIAEoCRIUCgx3b3Jrc3BhY2VfaWQYAiABKAkSEwoLY2FsZW5kYXJfaWQYAyABKAkSDQoFdGl0bGUYBCABKAkSGAoLZGVzY3JpcHRpb24YBSABKAlIAIgBARISCgVpbWFnZRgLIAEoCUgBiAEBEg8KB2FsbF9kYXkYBiABKAgSLgoKc3RhcnRfdGltZRgHIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASLAoIZW5kX3RpbWUYCCABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEhAKCHRpbWV6b25lGAkgASgJEhcKD3JlY3VycmVuY2VfcnVsZRgKIAEoCRInCgpwcm9wZXJ0aWVzGAwgAygLMhMuZXZlbnRzLnYxLlByb3BlcnR5Qg4KDF9kZXNjcmlwdGlvbkIICgZfaW1hZ2UiNgoTQ3JlYXRlRXZlbnRSZXNwb25zZRIfCgVldmVudBgBIAEoCzIQLmV2ZW50cy52MS5FdmVudCKPAQoSVXBkYXRlRXZlbnRSZXF1ZXN0Eh8KBWV2ZW50GAEgASgLMhAuZXZlbnRzLnYxLkV2ZW50EigKBG1hc2sYAiABKAsyGi5nb29nbGUucHJvdG9idWYuRmllbGRNYXNrEi4KDXVwZGF0ZV9wb2xpY3kYAyABKA4yFy5ldmVudHMudjEuVXBkYXRlUG9saWN5IjYKE1VwZGF0ZUV2ZW50UmVzcG9uc2USHwoFZXZlbnQYASABKAsyEC5ldmVudHMudjEuRXZlbnQiUAoSRGVsZXRlRXZlbnRSZXF1ZXN0EgoKAmlkGAEgASgJEi4KDWRlbGV0ZV9wb2xpY3kYAiABKA4yFy5ldmVudHMudjEuRGVsZXRlUG9saWN5IhUKE0RlbGV0ZUV2ZW50UmVzcG9uc2UqqgEKDFVwZGF0ZVBvbGljeRIdChlVUERBVEVfUE9MSUNZX1VOU1BFQ0lGSUVEEAASHAoYVVBEQVRFX1BPTElDWV9FVkVOVF9PTkxZEAESLAooVVBEQVRFX1BPTElDWV9FVkVOVF9XSVRIX0FMTF9PQ0NVUlJFTkNFUxACEi8KK1VQREFURV9QT0xJQ1lfRVZFTlRfV0lUSF9GVVRVUkVfT0NDVVJSRU5DRVMQAyqqAQoMRGVsZXRlUG9saWN5Eh0KGURFTEVURV9QT0xJQ1lfVU5TUEVDSUZJRUQQABIcChhERUxFVEVfUE9MSUNZX0VWRU5UX09OTFkQARIsCihERUxFVEVfUE9MSUNZX0VWRU5UX1dJVEhfQUxMX09DQ1VSUkVOQ0VTEAISLworREVMRVRFX1BPTElDWV9FVkVOVF9XSVRIX0ZVVFVSRV9PQ0NVUlJFTkNFUxADMsQICgxFdmVudFNlcnZpY2USWgoNTGlzdENhbGVuZGFycxIfLmV2ZW50cy52MS5MaXN0Q2FsZW5kYXJzUmVxdWVzdBogLmV2ZW50cy52MS5MaXN0Q2FsZW5kYXJzUmVzcG9uc2UiBsLtGgIIAhJUCgtHZXRDYWxlbmRhchIdLmV2ZW50cy52MS5HZXRDYWxlbmRhclJlcXVlc3QaHi5ldmVudHMudjEuR2V0Q2FsZW5kYXJSZXNwb25zZSIGwu0aAggCElEKCkxpc3RFdmVudHMSHC5ldmVudHMudjEuTGlzdEV2ZW50c1JlcXVlc3QaHS5ldmVudHMudjEuTGlzdEV2ZW50c1Jlc3BvbnNlIgbC7RoCCAISSwoIR2V0RXZlbnQSGi5ldmVudHMudjEuR2V0RXZlbnRSZXF1ZXN0GhsuZXZlbnRzLnYxLkdldEV2ZW50UmVzcG9uc2UiBsLtGgIIAhJYCg1HZXRMaXZlRXZlbnRzEh8uZXZlbnRzLnYxLkdldExpdmVFdmVudHNSZXF1ZXN0GiAuZXZlbnRzLnYxLkdldExpdmVFdmVudHNSZXNwb25zZSIEwu0aABJpChJHZXRFdmVudFByb3BlcnRpZXMSJC5ldmVudHMudjEuR2V0RXZlbnRQcm9wZXJ0aWVzUmVxdWVzdBolLmV2ZW50cy52MS5HZXRFdmVudFByb3BlcnRpZXNSZXNwb25zZSIGwu0aAggCElQKC0NyZWF0ZUV2ZW50Eh0uZXZlbnRzLnYxLkNyZWF0ZUV2ZW50UmVxdWVzdBoeLmV2ZW50cy52MS5DcmVhdGVFdmVudFJlc3BvbnNlIgbC7RoCCAISVAoLVXBkYXRlRXZlbnQSHS5ldmVudHMudjEuVXBkYXRlRXZlbnRSZXF1ZXN0Gh4uZXZlbnRzLnYxLlVwZGF0ZUV2ZW50UmVzcG9uc2UiBsLtGgIIAhJUCgtEZWxldGVFdmVudBIdLmV2ZW50cy52MS5EZWxldGVFdmVudFJlcXVlc3QaHi5ldmVudHMudjEuRGVsZXRlRXZlbnRSZXNwb25zZSIGwu0aAggCEl0KDkNyZWF0ZUNhbGVuZGFyEiAuZXZlbnRzLnYxLkNyZWF0ZUNhbGVuZGFyUmVxdWVzdBohLmV2ZW50cy52MS5DcmVhdGVDYWxlbmRhclJlc3BvbnNlIgbC7RoCCAISXQoOVXBkYXRlQ2FsZW5kYXISIC5ldmVudHMudjEuVXBkYXRlQ2FsZW5kYXJSZXF1ZXN0GiEuZXZlbnRzLnYxLlVwZGF0ZUNhbGVuZGFyUmVzcG9uc2UiBsLtGgIIAhJdCg5EZWxldGVDYWxlbmRhchIgLmV2ZW50cy52MS5EZWxldGVDYWxlbmRhclJlcXVlc3QaIS5ldmVudHMudjEuRGVsZXRlQ2FsZW5kYXJSZXNwb25zZSIGwu0aAggCYgZwcm90bzM",
		[file_common_v1_annotations, file_common_v1_types, file_events_v1_events, file_google_protobuf_field_mask, file_google_protobuf_struct, file_google_protobuf_timestamp],
	);

/**
 * @generated from message events.v1.ListCalendarsRequest
 */
export type ListCalendarsRequest = Message<"events.v1.ListCalendarsRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;
};

/**
 * @generated from message events.v1.ListCalendarsRequest
 */
export type ListCalendarsRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;
};

/**
 * Describes the message events.v1.ListCalendarsRequest.
 * Use `create(ListCalendarsRequestSchema)` to create a new message.
 */
export const ListCalendarsRequestSchema: GenMessage<ListCalendarsRequest, { jsonType: ListCalendarsRequestJson }> = /*@__PURE__*/ messageDesc(file_events_v1_service, 0);

/**
 * @generated from message events.v1.ListCalendarsResponse
 */
export type ListCalendarsResponse = Message<"events.v1.ListCalendarsResponse"> & {
	/**
	 * @generated from field: repeated events.v1.Calendar calendars = 1;
	 */
	calendars: Calendar[];
};

/**
 * @generated from message events.v1.ListCalendarsResponse
 */
export type ListCalendarsResponseJson = {
	/**
	 * @generated from field: repeated events.v1.Calendar calendars = 1;
	 */
	calendars?: CalendarJson[];
};

/**
 * Describes the message events.v1.ListCalendarsResponse.
 * Use `create(ListCalendarsResponseSchema)` to create a new message.
 */
export const ListCalendarsResponseSchema: GenMessage<ListCalendarsResponse, { jsonType: ListCalendarsResponseJson }> = /*@__PURE__*/ messageDesc(file_events_v1_service, 1);

/**
 * @generated from message events.v1.GetCalendarRequest
 */
export type GetCalendarRequest = Message<"events.v1.GetCalendarRequest"> & {
	/**
	 * @generated from field: string id = 3;
	 */
	id: string;
};

/**
 * @generated from message events.v1.GetCalendarRequest
 */
export type GetCalendarRequestJson = {
	/**
	 * @generated from field: string id = 3;
	 */
	id?: string;
};

/**
 * Describes the message events.v1.GetCalendarRequest.
 * Use `create(GetCalendarRequestSchema)` to create a new message.
 */
export const GetCalendarRequestSchema: GenMessage<GetCalendarRequest, { jsonType: GetCalendarRequestJson }> = /*@__PURE__*/ messageDesc(file_events_v1_service, 2);

/**
 * @generated from message events.v1.GetCalendarResponse
 */
export type GetCalendarResponse = Message<"events.v1.GetCalendarResponse"> & {
	/**
	 * @generated from field: events.v1.Calendar calendar = 1;
	 */
	calendar?: Calendar | undefined;
};

/**
 * @generated from message events.v1.GetCalendarResponse
 */
export type GetCalendarResponseJson = {
	/**
	 * @generated from field: events.v1.Calendar calendar = 1;
	 */
	calendar?: CalendarJson;
};

/**
 * Describes the message events.v1.GetCalendarResponse.
 * Use `create(GetCalendarResponseSchema)` to create a new message.
 */
export const GetCalendarResponseSchema: GenMessage<GetCalendarResponse, { jsonType: GetCalendarResponseJson }> = /*@__PURE__*/ messageDesc(file_events_v1_service, 3);

/**
 * @generated from message events.v1.CreateCalendarRequest
 */
export type CreateCalendarRequest = Message<"events.v1.CreateCalendarRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * @generated from field: string name = 3;
	 */
	name: string;

	/**
	 * @generated from field: string color_code = 4;
	 */
	colorCode: string;

	/**
	 * @generated from field: bool is_default = 5;
	 */
	isDefault: boolean;
};

/**
 * @generated from message events.v1.CreateCalendarRequest
 */
export type CreateCalendarRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: string name = 3;
	 */
	name?: string;

	/**
	 * @generated from field: string color_code = 4;
	 */
	colorCode?: string;

	/**
	 * @generated from field: bool is_default = 5;
	 */
	isDefault?: boolean;
};

/**
 * Describes the message events.v1.CreateCalendarRequest.
 * Use `create(CreateCalendarRequestSchema)` to create a new message.
 */
export const CreateCalendarRequestSchema: GenMessage<CreateCalendarRequest, { jsonType: CreateCalendarRequestJson }> = /*@__PURE__*/ messageDesc(file_events_v1_service, 4);

/**
 * @generated from message events.v1.CreateCalendarResponse
 */
export type CreateCalendarResponse = Message<"events.v1.CreateCalendarResponse"> & {
	/**
	 * @generated from field: events.v1.Calendar calendar = 1;
	 */
	calendar?: Calendar | undefined;
};

/**
 * @generated from message events.v1.CreateCalendarResponse
 */
export type CreateCalendarResponseJson = {
	/**
	 * @generated from field: events.v1.Calendar calendar = 1;
	 */
	calendar?: CalendarJson;
};

/**
 * Describes the message events.v1.CreateCalendarResponse.
 * Use `create(CreateCalendarResponseSchema)` to create a new message.
 */
export const CreateCalendarResponseSchema: GenMessage<CreateCalendarResponse, { jsonType: CreateCalendarResponseJson }> = /*@__PURE__*/ messageDesc(file_events_v1_service, 5);

/**
 * @generated from message events.v1.UpdateCalendarRequest
 */
export type UpdateCalendarRequest = Message<"events.v1.UpdateCalendarRequest"> & {
	/**
	 * @generated from field: events.v1.Calendar calendar = 1;
	 */
	calendar?: Calendar | undefined;

	/**
	 * @generated from field: google.protobuf.FieldMask mask = 2;
	 */
	mask?: FieldMask | undefined;
};

/**
 * @generated from message events.v1.UpdateCalendarRequest
 */
export type UpdateCalendarRequestJson = {
	/**
	 * @generated from field: events.v1.Calendar calendar = 1;
	 */
	calendar?: CalendarJson;

	/**
	 * @generated from field: google.protobuf.FieldMask mask = 2;
	 */
	mask?: FieldMaskJson;
};

/**
 * Describes the message events.v1.UpdateCalendarRequest.
 * Use `create(UpdateCalendarRequestSchema)` to create a new message.
 */
export const UpdateCalendarRequestSchema: GenMessage<UpdateCalendarRequest, { jsonType: UpdateCalendarRequestJson }> = /*@__PURE__*/ messageDesc(file_events_v1_service, 6);

/**
 * @generated from message events.v1.UpdateCalendarResponse
 */
export type UpdateCalendarResponse = Message<"events.v1.UpdateCalendarResponse"> & {
	/**
	 * @generated from field: events.v1.Calendar calendar = 1;
	 */
	calendar?: Calendar | undefined;
};

/**
 * @generated from message events.v1.UpdateCalendarResponse
 */
export type UpdateCalendarResponseJson = {
	/**
	 * @generated from field: events.v1.Calendar calendar = 1;
	 */
	calendar?: CalendarJson;
};

/**
 * Describes the message events.v1.UpdateCalendarResponse.
 * Use `create(UpdateCalendarResponseSchema)` to create a new message.
 */
export const UpdateCalendarResponseSchema: GenMessage<UpdateCalendarResponse, { jsonType: UpdateCalendarResponseJson }> = /*@__PURE__*/ messageDesc(file_events_v1_service, 7);

/**
 * @generated from message events.v1.DeleteCalendarRequest
 */
export type DeleteCalendarRequest = Message<"events.v1.DeleteCalendarRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;
};

/**
 * @generated from message events.v1.DeleteCalendarRequest
 */
export type DeleteCalendarRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;
};

/**
 * Describes the message events.v1.DeleteCalendarRequest.
 * Use `create(DeleteCalendarRequestSchema)` to create a new message.
 */
export const DeleteCalendarRequestSchema: GenMessage<DeleteCalendarRequest, { jsonType: DeleteCalendarRequestJson }> = /*@__PURE__*/ messageDesc(file_events_v1_service, 8);

/**
 * @generated from message events.v1.DeleteCalendarResponse
 */
export type DeleteCalendarResponse = Message<"events.v1.DeleteCalendarResponse"> & {};

/**
 * @generated from message events.v1.DeleteCalendarResponse
 */
export type DeleteCalendarResponseJson = {};

/**
 * Describes the message events.v1.DeleteCalendarResponse.
 * Use `create(DeleteCalendarResponseSchema)` to create a new message.
 */
export const DeleteCalendarResponseSchema: GenMessage<DeleteCalendarResponse, { jsonType: DeleteCalendarResponseJson }> = /*@__PURE__*/ messageDesc(file_events_v1_service, 9);

/**
 * @generated from message events.v1.EventFilter
 */
export type EventFilter = Message<"events.v1.EventFilter"> & {
	/**
	 * @generated from field: repeated string calendar_ids = 1;
	 */
	calendarIds: string[];

	/**
	 * @generated from field: google.protobuf.Timestamp start_time = 2;
	 */
	startTime?: Timestamp | undefined;

	/**
	 * @generated from field: google.protobuf.Timestamp end_time = 3;
	 */
	endTime?: Timestamp | undefined;
};

/**
 * @generated from message events.v1.EventFilter
 */
export type EventFilterJson = {
	/**
	 * @generated from field: repeated string calendar_ids = 1;
	 */
	calendarIds?: string[];

	/**
	 * @generated from field: google.protobuf.Timestamp start_time = 2;
	 */
	startTime?: TimestampJson;

	/**
	 * @generated from field: google.protobuf.Timestamp end_time = 3;
	 */
	endTime?: TimestampJson;
};

/**
 * Describes the message events.v1.EventFilter.
 * Use `create(EventFilterSchema)` to create a new message.
 */
export const EventFilterSchema: GenMessage<EventFilter, { jsonType: EventFilterJson }> = /*@__PURE__*/ messageDesc(file_events_v1_service, 10);

/**
 * @generated from message events.v1.ListEventsRequest
 */
export type ListEventsRequest = Message<"events.v1.ListEventsRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * @generated from field: optional events.v1.EventFilter filter = 3;
	 */
	filter?: EventFilter | undefined;
};

/**
 * @generated from message events.v1.ListEventsRequest
 */
export type ListEventsRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: optional events.v1.EventFilter filter = 3;
	 */
	filter?: EventFilterJson;
};

/**
 * Describes the message events.v1.ListEventsRequest.
 * Use `create(ListEventsRequestSchema)` to create a new message.
 */
export const ListEventsRequestSchema: GenMessage<ListEventsRequest, { jsonType: ListEventsRequestJson }> = /*@__PURE__*/ messageDesc(file_events_v1_service, 11);

/**
 * @generated from message events.v1.ListEventsResponse
 */
export type ListEventsResponse = Message<"events.v1.ListEventsResponse"> & {
	/**
	 * @generated from field: repeated events.v1.Event events = 1;
	 */
	events: Event[];
};

/**
 * @generated from message events.v1.ListEventsResponse
 */
export type ListEventsResponseJson = {
	/**
	 * @generated from field: repeated events.v1.Event events = 1;
	 */
	events?: EventJson[];
};

/**
 * Describes the message events.v1.ListEventsResponse.
 * Use `create(ListEventsResponseSchema)` to create a new message.
 */
export const ListEventsResponseSchema: GenMessage<ListEventsResponse, { jsonType: ListEventsResponseJson }> = /*@__PURE__*/ messageDesc(file_events_v1_service, 12);

/**
 * @generated from message events.v1.GetEventRequest
 */
export type GetEventRequest = Message<"events.v1.GetEventRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;
};

/**
 * @generated from message events.v1.GetEventRequest
 */
export type GetEventRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;
};

/**
 * Describes the message events.v1.GetEventRequest.
 * Use `create(GetEventRequestSchema)` to create a new message.
 */
export const GetEventRequestSchema: GenMessage<GetEventRequest, { jsonType: GetEventRequestJson }> = /*@__PURE__*/ messageDesc(file_events_v1_service, 13);

/**
 * @generated from message events.v1.GetEventResponse
 */
export type GetEventResponse = Message<"events.v1.GetEventResponse"> & {
	/**
	 * @generated from field: events.v1.Event event = 1;
	 */
	event?: Event | undefined;
};

/**
 * @generated from message events.v1.GetEventResponse
 */
export type GetEventResponseJson = {
	/**
	 * @generated from field: events.v1.Event event = 1;
	 */
	event?: EventJson;
};

/**
 * Describes the message events.v1.GetEventResponse.
 * Use `create(GetEventResponseSchema)` to create a new message.
 */
export const GetEventResponseSchema: GenMessage<GetEventResponse, { jsonType: GetEventResponseJson }> = /*@__PURE__*/ messageDesc(file_events_v1_service, 14);

/**
 * @generated from message events.v1.GetLiveEventsRequest
 */
export type GetLiveEventsRequest = Message<"events.v1.GetLiveEventsRequest"> & {
	/**
	 * @generated from field: repeated string calendar_ids = 1;
	 */
	calendarIds: string[];
};

/**
 * @generated from message events.v1.GetLiveEventsRequest
 */
export type GetLiveEventsRequestJson = {
	/**
	 * @generated from field: repeated string calendar_ids = 1;
	 */
	calendarIds?: string[];
};

/**
 * Describes the message events.v1.GetLiveEventsRequest.
 * Use `create(GetLiveEventsRequestSchema)` to create a new message.
 */
export const GetLiveEventsRequestSchema: GenMessage<GetLiveEventsRequest, { jsonType: GetLiveEventsRequestJson }> = /*@__PURE__*/ messageDesc(file_events_v1_service, 15);

/**
 * @generated from message events.v1.GetLiveEventsResponse
 */
export type GetLiveEventsResponse = Message<"events.v1.GetLiveEventsResponse"> & {
	/**
	 * @generated from field: repeated events.v1.Event events = 1;
	 */
	events: Event[];
};

/**
 * @generated from message events.v1.GetLiveEventsResponse
 */
export type GetLiveEventsResponseJson = {
	/**
	 * @generated from field: repeated events.v1.Event events = 1;
	 */
	events?: EventJson[];
};

/**
 * Describes the message events.v1.GetLiveEventsResponse.
 * Use `create(GetLiveEventsResponseSchema)` to create a new message.
 */
export const GetLiveEventsResponseSchema: GenMessage<GetLiveEventsResponse, { jsonType: GetLiveEventsResponseJson }> = /*@__PURE__*/ messageDesc(file_events_v1_service, 16);

/**
 * @generated from message events.v1.GetEventPropertiesRequest
 */
export type GetEventPropertiesRequest = Message<"events.v1.GetEventPropertiesRequest"> & {
	/**
	 * @generated from field: repeated string calendar_ids = 1;
	 */
	calendarIds: string[];
};

/**
 * @generated from message events.v1.GetEventPropertiesRequest
 */
export type GetEventPropertiesRequestJson = {
	/**
	 * @generated from field: repeated string calendar_ids = 1;
	 */
	calendarIds?: string[];
};

/**
 * Describes the message events.v1.GetEventPropertiesRequest.
 * Use `create(GetEventPropertiesRequestSchema)` to create a new message.
 */
export const GetEventPropertiesRequestSchema: GenMessage<GetEventPropertiesRequest, { jsonType: GetEventPropertiesRequestJson }> = /*@__PURE__*/ messageDesc(file_events_v1_service, 17);

/**
 * @generated from message events.v1.GetEventPropertiesResponse
 */
export type GetEventPropertiesResponse = Message<"events.v1.GetEventPropertiesResponse"> & {
	/**
	 * @generated from field: map<string, common.v1.DataType> properties = 1;
	 */
	properties: { [key: string]: DataType };
};

/**
 * @generated from message events.v1.GetEventPropertiesResponse
 */
export type GetEventPropertiesResponseJson = {
	/**
	 * @generated from field: map<string, common.v1.DataType> properties = 1;
	 */
	properties?: { [key: string]: DataTypeJson };
};

/**
 * Describes the message events.v1.GetEventPropertiesResponse.
 * Use `create(GetEventPropertiesResponseSchema)` to create a new message.
 */
export const GetEventPropertiesResponseSchema: GenMessage<GetEventPropertiesResponse, { jsonType: GetEventPropertiesResponseJson }> = /*@__PURE__*/ messageDesc(file_events_v1_service, 18);

/**
 * @generated from message events.v1.CreateEventRequest
 */
export type CreateEventRequest = Message<"events.v1.CreateEventRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * @generated from field: string calendar_id = 3;
	 */
	calendarId: string;

	/**
	 * @generated from field: string title = 4;
	 */
	title: string;

	/**
	 * @generated from field: optional string description = 5;
	 */
	description?: string | undefined;

	/**
	 * @generated from field: optional string image = 11;
	 */
	image?: string | undefined;

	/**
	 * @generated from field: bool all_day = 6;
	 */
	allDay: boolean;

	/**
	 * @generated from field: google.protobuf.Timestamp start_time = 7;
	 */
	startTime?: Timestamp | undefined;

	/**
	 * @generated from field: google.protobuf.Timestamp end_time = 8;
	 */
	endTime?: Timestamp | undefined;

	/**
	 * @generated from field: string timezone = 9;
	 */
	timezone: string;

	/**
	 * @generated from field: string recurrence_rule = 10;
	 */
	recurrenceRule: string;

	/**
	 * @generated from field: repeated events.v1.Property properties = 12;
	 */
	properties: Property[];
};

/**
 * @generated from message events.v1.CreateEventRequest
 */
export type CreateEventRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: string calendar_id = 3;
	 */
	calendarId?: string;

	/**
	 * @generated from field: string title = 4;
	 */
	title?: string;

	/**
	 * @generated from field: optional string description = 5;
	 */
	description?: string;

	/**
	 * @generated from field: optional string image = 11;
	 */
	image?: string;

	/**
	 * @generated from field: bool all_day = 6;
	 */
	allDay?: boolean;

	/**
	 * @generated from field: google.protobuf.Timestamp start_time = 7;
	 */
	startTime?: TimestampJson;

	/**
	 * @generated from field: google.protobuf.Timestamp end_time = 8;
	 */
	endTime?: TimestampJson;

	/**
	 * @generated from field: string timezone = 9;
	 */
	timezone?: string;

	/**
	 * @generated from field: string recurrence_rule = 10;
	 */
	recurrenceRule?: string;

	/**
	 * @generated from field: repeated events.v1.Property properties = 12;
	 */
	properties?: PropertyJson[];
};

/**
 * Describes the message events.v1.CreateEventRequest.
 * Use `create(CreateEventRequestSchema)` to create a new message.
 */
export const CreateEventRequestSchema: GenMessage<CreateEventRequest, { jsonType: CreateEventRequestJson }> = /*@__PURE__*/ messageDesc(file_events_v1_service, 19);

/**
 * @generated from message events.v1.CreateEventResponse
 */
export type CreateEventResponse = Message<"events.v1.CreateEventResponse"> & {
	/**
	 * @generated from field: events.v1.Event event = 1;
	 */
	event?: Event | undefined;
};

/**
 * @generated from message events.v1.CreateEventResponse
 */
export type CreateEventResponseJson = {
	/**
	 * @generated from field: events.v1.Event event = 1;
	 */
	event?: EventJson;
};

/**
 * Describes the message events.v1.CreateEventResponse.
 * Use `create(CreateEventResponseSchema)` to create a new message.
 */
export const CreateEventResponseSchema: GenMessage<CreateEventResponse, { jsonType: CreateEventResponseJson }> = /*@__PURE__*/ messageDesc(file_events_v1_service, 20);

/**
 * @generated from message events.v1.UpdateEventRequest
 */
export type UpdateEventRequest = Message<"events.v1.UpdateEventRequest"> & {
	/**
	 * @generated from field: events.v1.Event event = 1;
	 */
	event?: Event | undefined;

	/**
	 * @generated from field: google.protobuf.FieldMask mask = 2;
	 */
	mask?: FieldMask | undefined;

	/**
	 * @generated from field: events.v1.UpdatePolicy update_policy = 3;
	 */
	updatePolicy: UpdatePolicy;
};

/**
 * @generated from message events.v1.UpdateEventRequest
 */
export type UpdateEventRequestJson = {
	/**
	 * @generated from field: events.v1.Event event = 1;
	 */
	event?: EventJson;

	/**
	 * @generated from field: google.protobuf.FieldMask mask = 2;
	 */
	mask?: FieldMaskJson;

	/**
	 * @generated from field: events.v1.UpdatePolicy update_policy = 3;
	 */
	updatePolicy?: UpdatePolicyJson;
};

/**
 * Describes the message events.v1.UpdateEventRequest.
 * Use `create(UpdateEventRequestSchema)` to create a new message.
 */
export const UpdateEventRequestSchema: GenMessage<UpdateEventRequest, { jsonType: UpdateEventRequestJson }> = /*@__PURE__*/ messageDesc(file_events_v1_service, 21);

/**
 * @generated from message events.v1.UpdateEventResponse
 */
export type UpdateEventResponse = Message<"events.v1.UpdateEventResponse"> & {
	/**
	 * @generated from field: events.v1.Event event = 1;
	 */
	event?: Event | undefined;
};

/**
 * @generated from message events.v1.UpdateEventResponse
 */
export type UpdateEventResponseJson = {
	/**
	 * @generated from field: events.v1.Event event = 1;
	 */
	event?: EventJson;
};

/**
 * Describes the message events.v1.UpdateEventResponse.
 * Use `create(UpdateEventResponseSchema)` to create a new message.
 */
export const UpdateEventResponseSchema: GenMessage<UpdateEventResponse, { jsonType: UpdateEventResponseJson }> = /*@__PURE__*/ messageDesc(file_events_v1_service, 22);

/**
 * @generated from message events.v1.DeleteEventRequest
 */
export type DeleteEventRequest = Message<"events.v1.DeleteEventRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: events.v1.DeletePolicy delete_policy = 2;
	 */
	deletePolicy: DeletePolicy;
};

/**
 * @generated from message events.v1.DeleteEventRequest
 */
export type DeleteEventRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: events.v1.DeletePolicy delete_policy = 2;
	 */
	deletePolicy?: DeletePolicyJson;
};

/**
 * Describes the message events.v1.DeleteEventRequest.
 * Use `create(DeleteEventRequestSchema)` to create a new message.
 */
export const DeleteEventRequestSchema: GenMessage<DeleteEventRequest, { jsonType: DeleteEventRequestJson }> = /*@__PURE__*/ messageDesc(file_events_v1_service, 23);

/**
 * @generated from message events.v1.DeleteEventResponse
 */
export type DeleteEventResponse = Message<"events.v1.DeleteEventResponse"> & {};

/**
 * @generated from message events.v1.DeleteEventResponse
 */
export type DeleteEventResponseJson = {};

/**
 * Describes the message events.v1.DeleteEventResponse.
 * Use `create(DeleteEventResponseSchema)` to create a new message.
 */
export const DeleteEventResponseSchema: GenMessage<DeleteEventResponse, { jsonType: DeleteEventResponseJson }> = /*@__PURE__*/ messageDesc(file_events_v1_service, 24);

/**
 * @generated from enum events.v1.UpdatePolicy
 */
export enum UpdatePolicy {
	/**
	 * @generated from enum value: UPDATE_POLICY_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: UPDATE_POLICY_EVENT_ONLY = 1;
	 */
	EVENT_ONLY = 1,

	/**
	 * @generated from enum value: UPDATE_POLICY_EVENT_WITH_ALL_OCCURRENCES = 2;
	 */
	EVENT_WITH_ALL_OCCURRENCES = 2,

	/**
	 * @generated from enum value: UPDATE_POLICY_EVENT_WITH_FUTURE_OCCURRENCES = 3;
	 */
	EVENT_WITH_FUTURE_OCCURRENCES = 3,
}

/**
 * @generated from enum events.v1.UpdatePolicy
 */
export type UpdatePolicyJson = "UPDATE_POLICY_UNSPECIFIED" | "UPDATE_POLICY_EVENT_ONLY" | "UPDATE_POLICY_EVENT_WITH_ALL_OCCURRENCES" | "UPDATE_POLICY_EVENT_WITH_FUTURE_OCCURRENCES";

/**
 * Describes the enum events.v1.UpdatePolicy.
 */
export const UpdatePolicySchema: GenEnum<UpdatePolicy, UpdatePolicyJson> = /*@__PURE__*/ enumDesc(file_events_v1_service, 0);

/**
 * @generated from enum events.v1.DeletePolicy
 */
export enum DeletePolicy {
	/**
	 * @generated from enum value: DELETE_POLICY_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: DELETE_POLICY_EVENT_ONLY = 1;
	 */
	EVENT_ONLY = 1,

	/**
	 * @generated from enum value: DELETE_POLICY_EVENT_WITH_ALL_OCCURRENCES = 2;
	 */
	EVENT_WITH_ALL_OCCURRENCES = 2,

	/**
	 * @generated from enum value: DELETE_POLICY_EVENT_WITH_FUTURE_OCCURRENCES = 3;
	 */
	EVENT_WITH_FUTURE_OCCURRENCES = 3,
}

/**
 * @generated from enum events.v1.DeletePolicy
 */
export type DeletePolicyJson = "DELETE_POLICY_UNSPECIFIED" | "DELETE_POLICY_EVENT_ONLY" | "DELETE_POLICY_EVENT_WITH_ALL_OCCURRENCES" | "DELETE_POLICY_EVENT_WITH_FUTURE_OCCURRENCES";

/**
 * Describes the enum events.v1.DeletePolicy.
 */
export const DeletePolicySchema: GenEnum<DeletePolicy, DeletePolicyJson> = /*@__PURE__*/ enumDesc(file_events_v1_service, 1);

/**
 * @generated from service events.v1.EventService
 */
export const EventService: GenService<{
	/**
	 * @generated from rpc events.v1.EventService.ListCalendars
	 */
	listCalendars: {
		methodKind: "unary";
		input: typeof ListCalendarsRequestSchema;
		output: typeof ListCalendarsResponseSchema;
	};
	/**
	 * @generated from rpc events.v1.EventService.GetCalendar
	 */
	getCalendar: {
		methodKind: "unary";
		input: typeof GetCalendarRequestSchema;
		output: typeof GetCalendarResponseSchema;
	};
	/**
	 * @generated from rpc events.v1.EventService.ListEvents
	 */
	listEvents: {
		methodKind: "unary";
		input: typeof ListEventsRequestSchema;
		output: typeof ListEventsResponseSchema;
	};
	/**
	 * @generated from rpc events.v1.EventService.GetEvent
	 */
	getEvent: {
		methodKind: "unary";
		input: typeof GetEventRequestSchema;
		output: typeof GetEventResponseSchema;
	};
	/**
	 * @generated from rpc events.v1.EventService.GetLiveEvents
	 */
	getLiveEvents: {
		methodKind: "unary";
		input: typeof GetLiveEventsRequestSchema;
		output: typeof GetLiveEventsResponseSchema;
	};
	/**
	 * @generated from rpc events.v1.EventService.GetEventProperties
	 */
	getEventProperties: {
		methodKind: "unary";
		input: typeof GetEventPropertiesRequestSchema;
		output: typeof GetEventPropertiesResponseSchema;
	};
	/**
	 * @generated from rpc events.v1.EventService.CreateEvent
	 */
	createEvent: {
		methodKind: "unary";
		input: typeof CreateEventRequestSchema;
		output: typeof CreateEventResponseSchema;
	};
	/**
	 * @generated from rpc events.v1.EventService.UpdateEvent
	 */
	updateEvent: {
		methodKind: "unary";
		input: typeof UpdateEventRequestSchema;
		output: typeof UpdateEventResponseSchema;
	};
	/**
	 * @generated from rpc events.v1.EventService.DeleteEvent
	 */
	deleteEvent: {
		methodKind: "unary";
		input: typeof DeleteEventRequestSchema;
		output: typeof DeleteEventResponseSchema;
	};
	/**
	 * @generated from rpc events.v1.EventService.CreateCalendar
	 */
	createCalendar: {
		methodKind: "unary";
		input: typeof CreateCalendarRequestSchema;
		output: typeof CreateCalendarResponseSchema;
	};
	/**
	 * @generated from rpc events.v1.EventService.UpdateCalendar
	 */
	updateCalendar: {
		methodKind: "unary";
		input: typeof UpdateCalendarRequestSchema;
		output: typeof UpdateCalendarResponseSchema;
	};
	/**
	 * @generated from rpc events.v1.EventService.DeleteCalendar
	 */
	deleteCalendar: {
		methodKind: "unary";
		input: typeof DeleteCalendarRequestSchema;
		output: typeof DeleteCalendarResponseSchema;
	};
}> = /*@__PURE__*/ serviceDesc(file_events_v1_service, 0);
